<template>
    <Link :href="href" :class="classes">
        <slot />
    </Link>
</template>

<script>
    import { defineComponent } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';

    export default defineComponent({
        components: {
            Link,
        },
        props: ['href', 'active'],

        computed: {
            classes() {
                return this.active
                    ? 'inline-flex items-center px-1 border-b-4 border-pGray-900 text-sm font-medium leading-5 text-pGray focus:outline-none focus:border-pGray-900 transition font-bold'
                    : 'inline-flex items-center px-1 border-b-4 border-transparent text-sm font-medium leading-5 text-pGray hover:text-primary-300 hover:border-pGray-900 focus:outline-none focus:text-primary-700 focus:border-pGray-900 transition font-bold'
            }
        }
    })
</script>
